/* S4Y Konfigurator · Standard-Karten (14.10.26, Daniel 12:28: „alle so darstellen wie die Serviceleistungen – Standard angeklickt, ansonsten wechseln“).
   Sitzaufbau, Elektrisch und Hocker zeigen ihre Auswahl ohne Aufklapp-Kachel (CSS in s4y-optik-b5.css).
   Hier kommt bei Elektrisch und Hocker oben eine Standard-Karte dazu („Nicht elektrisch“ / „Kein Hocker“): angehakt, solange nichts
   dazugebucht ist; Antippen setzt auf Standard zurück. Hocker-Größen sind angehakt, solange ein Hocker in dieser Größe gewählt ist;
   nochmal Antippen nimmt ihn wieder heraus (mehrere Hocker gehen weiter über „Duplizieren“ am Hocker).
   Es werden nur die vorhandenen Knöpfe des Konfigurators benutzt (Auswahl-Zeilen, × beim Hocker) – keine eigene Preis- oder
   Warenkorb-Logik. Eingebunden in sections/s4y-design.liquid.
   Dazu (Daniel 14.10., 13:30: „im Konfigurator standardmäßig Maße aktivieren“): Die Maße in der 3D-Ansicht sind beim Laden an. */
(function () {
  if (window.__s5Std) return; window.__s5Std = 1;
  var SEL_EL = '.sk-electric-list > .tk-dd > .tk-dd-list';
  var SEL_ON = '.tk-dd-opt:not(.s5-std):is(.active,[aria-selected="true"])';
  var SEL_HK = '[id^="sk-hocker-container"] .sk-h-card[data-hocker]';
  /* Größe einer Hocker-Auswahl („90 × 60 cm“) und eines gewählten Hockers (Regler Breite/Tiefe) als „90x60“ */
  function groesse(o) { var m = ((o.querySelector('.tk-dd-sub') || o).textContent || '').match(/(\d+)\s*[×x]\s*(\d+)/); return m ? m[1] + 'x' + m[2] : ''; }
  function hockerGroesse(c) {
    var w = c.querySelector('.sk-h-slider[data-dim="w"]'), d = c.querySelector('.sk-h-slider[data-dim="d"]');
    return w && d ? w.value + 'x' + d.value : '';
  }
  function hockerMit(root, g) {
    var cs = root.querySelectorAll(SEL_HK);
    for (var i = 0; i < cs.length; i++) if (hockerGroesse(cs[i]) === g) return cs[i];
    return null;
  }
  function mk(t, s) {
    var d = document.createElement('div');
    d.className = 'tk-dd-opt s5-std'; d.setAttribute('role', 'option'); d.tabIndex = 0;
    d.innerHTML = '<span class="tk-dd-txt"><span class="tk-dd-title"></span><span class="tk-dd-sub"></span></span><span class="tk-dd-check"></span>';
    d.querySelector('.tk-dd-title').textContent = t; d.querySelector('.tk-dd-sub').textContent = s;
    return d;
  }
  function mark(o, on) {
    o.classList.toggle('active', on); o.setAttribute('aria-selected', on ? 'true' : 'false');
    o.querySelector('.tk-dd-check').textContent = on ? '✓' : '';
  }
  /* nacheinander abwählen – die Liste wird dabei neu aufgebaut, darum jedes Mal neu suchen */
  function nimm(get) {
    var n = 0;
    (function step() {
      var b = get();
      if (!b || n++ > 12) { sync(); return; }
      b.click(); setTimeout(step, 150);
    })();
  }
  /* Maße an: einmal je Seitenaufruf den vorhandenen Maße-Knopf des 3D-Snippets auslösen. Der Knopf hört auch auf „pointerup“
     (am Handy wird „click“ in der Bühne abgefangen); der Zustand gilt dann für alle Ansichten und auch, wenn die 3D-Ansicht
     erst später lädt. Danach schaltet der Kunde wie gewohnt selbst ein und aus. */
  function masse(root) {
    if (root.__s5Dims) return;
    var b = root.querySelector('.sk3d-dims');
    if (!b) return;
    root.__s5Dims = 1;
    if (b.classList.contains('active')) return;
    try { b.dispatchEvent(new Event('pointerup', { bubbles: true })); } catch (e) {}
  }
  function sync() {
    var roots = document.querySelectorAll('[id^="sk-"].tkdd-on');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      masse(root);
      var hl = root.querySelector('.sk-h-picker-stds > .tk-dd > .tk-dd-list');
      if (hl) {
        var o = hl.querySelector(':scope > .s5-std');
        if (!o) {
          o = mk('Kein Hocker', 'Standard');
          o.addEventListener('click', (function (r) { return function (e) { e.stopPropagation(); e.preventDefault(); nimm(function () { return r.querySelector('[id^="sk-hocker-container"] .sk-h-remove'); }); }; })(root));
          hl.insertBefore(o, hl.firstChild);
        }
        mark(o, !root.querySelector('[id^="sk-hocker-container"] .sk-h-remove'));
        var gs = hl.querySelectorAll(':scope > .tk-dd-opt[data-i]');
        for (var j = 0; j < gs.length; j++) mark(gs[j], !!hockerMit(root, groesse(gs[j])));
      }
      var el = root.querySelector(SEL_EL);
      if (el) {
        var e2 = el.querySelector(':scope > .s5-std');
        if (!e2) {
          e2 = mk('Nicht elektrisch', 'Standard');
          e2.addEventListener('click', (function (r) { return function (e) { e.stopPropagation(); e.preventDefault(); nimm(function () { return r.querySelector(SEL_EL + ' ' + SEL_ON); }); }; })(root));
          el.insertBefore(e2, el.firstChild);
        }
        mark(e2, !el.querySelector(SEL_ON));
      }
    }
    return roots.length;
  }
  /* Seiten ohne Konfigurator: nach 10 Versuchen aufhören */
  var tries = 0;
  var iv = setInterval(function () { var n = sync(); if (!n && ++tries > 10) clearInterval(iv); }, 700);
  document.addEventListener('click', function () { setTimeout(sync, 60); setTimeout(sync, 400); }, true);
  /* angehakte Hocker-Größe nochmal antippen = diesen Hocker wieder herausnehmen (statt einen weiteren hinzuzufügen) */
  document.addEventListener('click', function (e) {
    var o = e.target && e.target.closest ? e.target.closest('.sk-h-picker-stds .tk-dd-opt[data-i]') : null;
    if (!o || !o.classList.contains('active')) return;
    var root = o.closest('[id^="sk-"].tkdd-on'), g = groesse(o);
    if (!root || !g) return;
    e.stopPropagation(); e.preventDefault();
    nimm(function () { var c = hockerMit(root, g); return c ? c.querySelector('.sk-h-remove') : null; });
  }, true);
})();
